import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "",
      name: "homePage",
      component: () => import("@/views/HomePage")
    },
    // 第三方登入隱私政策
    {
      path: "/privacy_policy",
      component: () => import("@/views/front/PrivacyPolicy"),
    },
    // SSO
    {
      path: "/ssoLogin",
      component: () => import("@/views/front/SSOLogin"),
    },
    /////應聘者//////////////////////////////////////////////////////
    {
      path: "/signIn",
      component: () => import("@/views/front/Candidate/SignIn/CandidateSignIn"),
    },
    
    {
      path: "/candidate",
      name: "CandidateLayout",
      component: () => import("@/views/front/Candidate/Layout/CandidateLayout"),
      children: [
        {
          path: "consentform",
          name: "DataConsent",
          component: () => import("@/views/front/Candidate/Form/DataConsent"),
        },
        {
          path: "jobopening",
          component: () =>
            import("@/views/front/Candidate/SignIn/Progress/JobOpening"),
            meta: { candidateAuth: true }
        },
        {
          path: "applicationrecord",
          component: () =>
            import("@/views/front/Candidate/SignIn/Progress/ApplicationRecord"),
            meta: { candidateAuth: true }
        },
        {
          path: "idl",
          name: "IDL 履歷",
          component: () => import("@/views/front/Candidate/Resume/IDL"),
          meta: { candidateAuth: true }
        },
        {
          path: "dl",
          name: "DL 履歷",
          component: () => import("@/views/front/Candidate/Resume/DL"),
          meta: { candidateAuth: true }
        },
      ],
    },

    /////管理者//////////////////////////////////////////////////////
    {
      path: "/login",
      component: () => import("@/views/back/Login/ManagerLogin"),
    },
    // 安裝頁面
    {
      path: "/setting",
      component: () => import("@/views/back/Index/Setting"),
    },

    //Feedback    
    {
      name: "Feedback",
      path: "/Feedback",
      component: () => import("@/views/back/MeetingRoom/Feedback"),
    },
    //邏輯考試    
    {
      name: "LogicExam",
      path: "/LogicExam",
      component: () => import("@/views/back/MeetingRoom/LogicExam"),
    },
    
        // 公播畫面
        {
          path: "/room/public_broadcast",
          name: "PublicBroadcast",
          component: () => import("@/views/back/MeetingRoom/PublicBroadcast"),
          meta: { managerAuth: true },
        },
    //全螢幕公播    
    // {
    //   name: "PublicBroadcastFull",
    //   path: "/PublicBroadcastFull",
    //   component: () => import("@/views/back/MeetingRoom/PublicBroadcastFull"),
    // },
    //全螢幕公播    
    // {
    //   name: "PublicBroadcastFullSpace",
    //   path: "/PublicBroadcastFullSpace",
    //   component: () => import("@/views/back/MeetingRoom/PublicBroadcastFullSpace"),
    // },

    
    {
      // 面談QrCode報到
      path: "/Checking",
      name: "Checking",
      component: () => import("@/views/back/MeetingRoom/Checking"),
      meta: { managerAuth: true },
    },

    {
      path: "/manager",
      component: () => import("@/views/back/Layout/ManagerLayout"),
      meta: { managerAuth: true },
      children: [
        {
          path: "index",
          component: () => import("@/views/back/Index/Index"),
          meta: { managerAuth: true },
        },
        {
          path: "survey/dashboard",
          component: () => import("@/views/back/SurveyManage/Dashboard"),
        },
        {
          path: "survey/create",
          component: () => import("@/views/back/SurveyManage/Create"),
        },
        {
          path: "survey/new",
          component: () => import("@/views/back/SurveyManage/New"),
        },
        {
          path: "chart/situation_room",
          name: "圖表分析,戰情室",
          component: () => import("@/views/back/Chart/SituationRoom"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "chart/login_record",
          name: "圖表分析,登入紀錄報表",
          component: () => import("@/views/back/Chart/LoginRecord"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "chart/blacklist",
          name: "圖表分析,黑名單報表",
          component: () => import("@/views/back/Chart/Blacklist"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "chart/recruit_progress",
          name: "圖表分析,階段占比報表",
          component: () => import("@/views/back/Chart/RecruitProgress"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "chart/recruit_progress_report",
          name: "圖表分析,招聘進度報表",
          component: () => import("@/views/back/Chart/RecruitmentProgressReport"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "systemDirections",
          name: "系統說明",
          component: () =>
            import("@/views/back/SystemDirections/SystemDirections"),
            meta: { managerAuth: true, keepAlive: false },
        },

        /////系統管理//////////////////////////////////////////////////////
        {
          path: "system/organization",
          name: "系統管理,組織管理",
          component: () => import("@/views/back/SystemManage/Department"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/features",
          name: "系統管理,功能管理",
          component: () => import("@/views/back/SystemManage/Features"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/role",
          name: "系統管理,角色管理",
          component: () => import("@/views/back/SystemManage/Role"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/menu",
          name: "系統管理,選單管理",
          component: () => import("@/views/back/SystemManage/Menu"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/parameter",
          name: "系統管理,參數設定",
          component: () => import("@/views/back/SystemManage/ParameterSetting"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/homepage",
          name: "系統管理,首頁管理",
          component: () => import("@/views/back/SystemManage/HomePage/Manage"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/localization",
          name: "系統管理,語系管理",
          component: () => import("@/views/back/SystemManage/Localization"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/schedule",
          name: "系統管理,排程管理",
          component: () => import("@/views/back/SystemManage/Schedule"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "system/emailrecord",
          name: "系統管理,信件紀錄",
          component: () => import("@/views/back/SystemManage/MailRecord"),
          meta: { managerAuth: true, keepAlive: false },
        },
        /////範本維護//////////////////////////////////////////////////////
        {
          path: "template/createtemplate",
          name: "範本維護,新增信件範本",
          component: () => import("@/components/back/LetterTemplate/AddLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/updatetemplate",
          name: "範本維護,編輯信件範本",
          component: () =>
            import("@/components/back/LetterTemplate/EditLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/jobintention",
          name: "範本維護,職缺意願",
          component: () =>
            import("@/views/back/TemplateMaintain/JobIntentionLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/interviewinvitation",
          name: "範本維護,面談邀約",
          component: () =>
            import("@/views/back/TemplateMaintain/InterviewLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/noticeinterview",
          name: "範本維護,提醒面談",
          component: () =>
            import("@/views/back/TemplateMaintain/NoticeInterviewLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/offerletter",
          name: "範本維護,錄取通知",
          component: () => import("@/views/back/TemplateMaintain/HireLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/thankyouletter",
          name: "範本維護,感謝函",
          component: () => import("@/views/back/TemplateMaintain/ThankLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/welcomeletter",
          name: "範本維護,報到通知",
          component: () => import("@/views/back/TemplateMaintain/ReportLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/noticeonboard",
          name: "範本維護,提醒報到",
          component: () =>
            import("@/views/back/TemplateMaintain/NoticeOnBoardLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/personaldataconsent",
          name: "範本維護,個資同意書",
          component: () => import("@/views/back/TemplateMaintain/ConsentForm"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/changepassword",
          name: "範本維護,變更密碼",
          component: () =>
            import("@/views/back/TemplateMaintain/PasswordLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/noticesubmitdocuments",
          name: "範本維護,提醒繳交文件",
          component: () =>
            import("@/views/back/TemplateMaintain/NoticeSubmitDocumentsLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/maintainoffer",
          name: "範本維護,offer維護",
          component: () =>
            import("@/views/back/TemplateMaintain/OfferMaintain"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "template/canned",
          name: "範本維護,罐頭訊息",
          component: () =>
            import("@/views/back/TemplateMaintain/CannedLetter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        /////招募設定//////////////////////////////////////////////////////
        {
          path: "setting/jobposition",
          name: "招募設定,職務維護",
          component: () => import("@/views/back/BaseDataManage/JobMaintenance"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "setting/workplace",
          name: "招募設定,工作地點維護",
          component: () =>
            import("@/views/back/BaseDataManage/WorkPlaceMaintenance"),
            meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "setting/contactinfo",
          name: "招募設定,聯絡資訊維護",
          component: () =>
            import("@/views/back/BaseDataManage/ContactInfoMaintenance"),
            meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "setting/interviewplace",
          name: "招募設定,面談地點維護",
          component: () =>
            import("@/views/back/BaseDataManage/InterviewPlaceMaintenance"),
            meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "setting/factory",
          name: "招募設定,廠別維護",
          component: () =>
            import("@/views/back/BaseDataManage/FactoryMaintenance"),
            meta: { managerAuth: true, keepAlive: false },
        },
        /////招募管理//////////////////////////////////////////////////////
        {
          path: "recruitment/personalapplication",
          name: "招募管理,需求申請",
          component: () =>
            import("@/views/back/RecruitManage/Demand/DemandApply"),
            meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "recruitment/applicationform",
          name: "招募管理,需求單",
          component: () =>
            import("@/views/back/RecruitManage/Demand/DemandForm"),
            meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "recruitment/updateapplication",
          name: "招募管理,編輯需求單",
          component: () =>
            import("@/views/back/RecruitManage/Demand/DemandEdit"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "recruitment/applicationhistory",
          name: "招募管理,需求查詢",
          component: () =>
            import("@/views/back/RecruitManage/Demand/DemandSearch"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "recruitment/applicationreview",
          name: "招募管理,需求審核",
          component: () =>
            import("@/views/back/RecruitManage/Demand/DemandReview"),
          meta: { managerAuth: true, keepAlive: false },
        },

        {
          path: "recruitment/jobopening",
          name: "招募管理,職缺管理",
          component: () => import("@/views/back/RecruitManage/OpeningManage"),
          meta: { managerAuth: true, keepAlive: true },
        },
        {
          path: "opening/resume",
          name: "職缺管理,履歷數量",
          component: () =>
            import("@/views/back/RecruitManage/RecruitStatus/ResumeList"),
          meta: { managerAuth: true, keepAlive: false },
          props: (route) => ({ did: route.query.did, kind: route.query.kind, pos: route.query.pos })
        },
        {
          path: "opening/inviteinterview",
          name: "職缺管理,待面談",
          component: () =>
            import("@/views/back/RecruitManage/RecruitStatus/Interviewing"),
          meta: { managerAuth: true, keepAlive: false },
          props: (route) => ({ did: route.query.did, kind: route.query.kind, pos: route.query.pos })
        },
        {
          path: "opening/closeinterview",
          name: "職缺管理,已面談",
          component: () =>
            import("@/views/back/RecruitManage/RecruitStatus/Interviewed"),
          meta: { managerAuth: true, keepAlive: false },
          props: (route) => ({ did: route.query.did, kind: route.query.kind, pos: route.query.pos })
        },
        {
          path: "recruitment/interviewhistory",
          name: "招募管理,填寫面談紀錄",
          component: () =>
            import("@/views/back/RecruitManage/InterviewHistory"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "form/interviewminutes",
          name: "職缺管理,面談紀錄表",
          component: () =>
            import("@/components/back/InterviewForm/CreateInterviewRecord"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "opening/declineinterview",
          name: "職缺管理,面談未到",
          component: () =>
            import("@/views/back/RecruitManage/RecruitStatus/DeclineInterview"),
            meta: { managerAuth: true, keepAlive: false },
            props: (route) => ({ did: route.query.did, kind: route.query.kind, pos: route.query.pos })
        },
        {
          path: "opening/interviewresult",
          name: "職缺管理,面談結果",
          component: () =>
            import("@/views/back/RecruitManage/RecruitStatus/InterviewResult"),
            meta: { managerAuth: true, keepAlive: false },
            props: (route) => ({ did: route.query.did, kind: route.query.kind, pos: route.query.pos })
        },

        {
          path: "form/evaluation/:Action/:MatchId",
          name: "招募管理,任用單",
          component: () =>
            import("@/components/back/AppointmentForm/TheAppointmentForm"),
          props: true,
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "form/evaluationreview",
          name: "招募管理,任用審核單",
          component: () =>
            import("@/components/back/AppointmentForm/ReviewAppointmentForm"),
          props: true,
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "opening/evaluationresult",
          name: "職缺管理,任用結果",
          component: () =>
            import("@/views/back/RecruitManage/RecruitStatus/AppointResult"),
          meta: { managerAuth: true, keepAlive: false },
          props: (route) => ({ did: route.query.did, kind: route.query.kind, pos: route.query.pos })
        },
        {
          path: "recruitment/evaluationreview",
          name: "招募管理,任用單審核",
          component: () =>
            import("@/views/back/RecruitManage/Appointment/AppointmentReview"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "recruitment/evaluationhistory",
          name: "招募管理,任用單查詢",
          component: () =>
            import("@/views/back/RecruitManage/Appointment/AppointmentSearch"),
          meta: { managerAuth: true, keepAlive: false },
        },

        {
          path: "form/dl/personnelinformation",
          name: "招募管理,人事資料表 ",
          component: () =>
            import("@/components/back/CandidateData/PersonnelInformation/DL"),
          meta: { managerAuth: true, keepAlive: false },
        },

        {
          path: "form/idl/personnelinformation",
          name: "招募管理,人事資料表",
          component: () =>
            import("@/components/back/CandidateData/PersonnelInformation/IDL"),
          meta: { managerAuth: true, keepAlive: false },
        },

        ///// 招聘進度 //////////////////////////////////////////////////////
        {
          path: "progress/invite_interview",
          name: "招聘進度,邀約面談",
          component: () =>
            import("@/views/back/RecruitProgress/Resume/InviteInterview"),
          meta: { managerAuth: true },
        },
        {
          path: "progress/resume_list",
          name: "招聘進度,履歷數量",
          component: () =>
            import("@/views/back/RecruitProgress/Resume/ResumeList"),
          meta: { managerAuth: true, keepAlive: false },
        },

        ///// 招聘進度-人資 //////////////////////////////////////////////////////
        {
          path: "progress/wait_interview",
          name: "招聘進度,待面談(人資)",
          component: () =>
            import("@/views/back/RecruitProgress/HR/WaitInterview"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/interviewed",
          name: "招聘進度,已面談(人資)",
          component: () =>
            import("@/views/back/RecruitProgress/HR/Interviewed"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/interview_result",
          name: "招聘進度,面談結果(人資)",
          component: () =>
            import("@/views/back/RecruitProgress/HR/InterviewResult"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/appointment_result",
          name: "招聘進度,任用結果(人資)",
          component: () =>
            import("@/views/back/RecruitProgress/HR/AppointResult"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/on_board",
          name: "招聘進度,報到查詢(人資)",
          component: () => import("@/views/back/RecruitProgress/HR/OnBoard"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/personaldocument",
          name: "招聘進度,報到資料",
          component: () =>
            import("@/views/back/RecruitProgress/HR/PersonalDocument"),
          meta: { managerAuth: true, keepAlive: false },
        },

        ///// 招聘進度-主管(限制) //////////////////////////////////////////////////////
        {
          path: "progress/supervisor_wait_interview",
          name: "招聘進度,待面談(主管)",
          component: () =>
            import("@/views/back/RecruitProgress/Supervisor/WaitInterview"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/supervisor_interviewed",
          name: "招聘進度,已面談(主管)",
          component: () =>
            import("@/views/back/RecruitProgress/Supervisor/Interviewed"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/supervisor_interview_result",
          name: "招聘進度,面談結果(主管)",
          component: () =>
            import("@/views/back/RecruitProgress/Supervisor/InterviewResult"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "progress/supervisor_appointment_result",
          name: "招聘進度,任用結果(主管)",
          component: () =>
            import("@/views/back/RecruitProgress/Supervisor/AppointResult"),
          meta: { managerAuth: true, keepAlive: false },
        },

        {
          path: "progress/supervisor_on_board",
          name: "招聘進度,報到查詢(主管)",
          component: () =>
            import("@/views/back/RecruitProgress/Supervisor/OnBoard"),
          meta: { managerAuth: true, keepAlive: false },
        },

        ///// RPA 模組 //////////////////////////////////////////////////////
        {
          path: "rpa/parameter",
          name: "RPA模組,排程設定",
          component: () => import("@/views/back/RPA/Parameter"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "rpa/schedule",
          name: "RPA模組,排程",
          component: () => import("@/views/back/RPA/Schedule"),
          meta: { managerAuth: true, keepAlive: false },
        },

        ///// 人才庫 //////////////////////////////////////////////////////
        {
          path: "talent/quick_search",
          name: "人才庫,人才查詢",
          component: () =>
            import("@/views/back/TalentQuery/SearchPage/QuickQuery"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "talent/limit_search",
          name: "人才庫,歷史人才查詢",
          component: () =>
            import("@/views/back/TalentQuery/SearchPage/LimitQuery"),
          meta: { managerAuth: true, keepAlive: false },
        },
        {
          path: "talent/complexquery",
          name: "人才庫,複合查詢",
          component: () =>
            import("@/views/back/TalentQuery/SearchPage/ComplexQuery"),
          meta: { managerAuth: true },
        },
        {
          path: "talent/queryresult",
          name: "人才庫,查詢結果",
          component: () =>
            import("@/views/back/TalentQuery/ResultPage/QueryResult"),
          meta: { managerAuth: true },
        },
        {
          path: "talent/resume_allocation",
          name: "人才庫,履歷分派",
          component: () =>
            import("@/views/back/TalentQuery/SearchPage/ResumeAllocation"),
          meta: { managerAuth: true },
        },
        {
          path: "talent/importing_resumes",
          name: "人才庫,匯入履歷",
          component: () => import("@/views/back/TalentQuery/ImportingResumes"),
          meta: { managerAuth: true },
        },

        ///// 面談室 //////////////////////////////////////////////////////
        {
          // 面談室維護
          path: "room/maintenance",
          name: "RoomMaintenance",
          component: () => import("@/views/back/MeetingRoom/RoomMaintenance"),
          meta: { managerAuth: true },
        },
        {
          // 面談流程管理
          path: "room/schedule_setting",
          name: "RoomScheduleSetting",
          component: () => import("@/views/back/MeetingRoom/RoomScheduleSetting"),
          meta: { managerAuth: true },
        },
        {
          // 面談流程報到
          path: "room/meeting_advance",
          name: "MeetingAdvance",
          component: () => import("@/views/back/MeetingRoom/MeetingAdvance"),
          meta: { managerAuth: true },
        },
        {
          // 面談室安排
          path: "room/room_arrangement",
          name: "RoomArrangement",
          component: () => import("@/views/back/MeetingRoom/RoomArrangement"),
          meta: { managerAuth: true },
        },
        // 面談室參數維護
        {
          path: "room/parameter",
          name: "RoomParameter",
          component: () => import("@/views/back/MeetingRoom/RoomParameter"),
          meta: { managerAuth: true },
        },
        // 面談流程總覽
        {
          path: "room/process_overview",
          name: "RoomProcessOverview",
          component: () => import("@/views/back/MeetingRoom/RoomProcessOverview"),
          meta: { managerAuth: true },
        },
        // 面談流程管理
        {
          path: "room/process_management",
          name: "RoomProcessManagement",
          component: () => import("@/views/back/MeetingRoom/RoomProcessManagement"),
          meta: { managerAuth: true },
        },
        // 滿意度問卷結果
        {
          path: "room/feedback_inquiry",
          name: "FeedbackInquiry",
          component: () => import("@/views/back/MeetingRoom/FeedbackInquiry"),
          meta: { managerAuth: true },
        },
        // 滿意度問卷
        {
          path: "IdlFeedback",
          name: "IdlFeedback",
          component: () => import("@/views/back/MeetingRoom/IdlFeedback"),
          meta: { managerAuth: true },
        },
        
        //面談室管理
        {
          path: "room/management",
          name: "面談排程管理,面談室管理",
          component: () => import("@/views/back/MeetingRoom/RoomManagement"),
          meta: { managerAuth: true },
        },
        //邏輯考試結果
        { 
          path: "room/logic_exam_results",
          name: "LogicExamResults",
          component: () => import("@/views/back/MeetingRoom/LogicExamResults"),
          meta: { managerAuth: true },
        },
        //邏輯考試結果
        { 
          path: "room/logic_exam_questions_maintenance",
          name: "LogicExamQuestionsMaintenance",
          component: () => import("@/views/back/MeetingRoom/LogicExamQuestionsMaintenance"),
          meta: { managerAuth: true },
        },
        //公播畫面設定
        { 
          path: "room/public_broadcast_settings",
          name: "PublicBroadcastSettings",
          component: () => import("@/views/back/MeetingRoom/PublicBroadcastSettings"),
          meta: { managerAuth: true },
        },
        
        //報表-面談流程
        { 
          path: "report/report_interview_process",
          name: "ReportInterviewProcess",
          component: () => import("@/views/back/MeetingRoom/ReportInterviewProcess"),
          meta: { managerAuth: true },
        },
        //報表-滿意度
        { 
          path: "report/report_satisfaction_survey",
          name: "ReportSatisfactionSurvey",
          component: () => import("@/views/back/MeetingRoom/ReportSatisfactionSurvey"),
          meta: { managerAuth: true },
        }
      ],
    },

    /////婉拒邀約//////////////////////////////////////////////////////
    {
      path: "/decline_report/:MatchId",
      component: () => import("@/views/front/Candidate/Form/Decline"),
    },

    /////重新整理//////////////////////////////////////////////////////
    {
      path: `/refresh`,
      name: "refresh",
      component: () => import("@/components/Refresh"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
